module.exports = __webpack_public_path__ + "img/view_module.f83fc1c8.svg";